export default __webpack_public_path__ + "static/media/dog.20f24ef3.jpg";